// React
import React from "react";
// React
// CSS
import styles from "./LessonStatus.module.css";
// CSS

import {GoArchive, GoFile, GoListUnordered, GoPerson} from "react-icons/go";
import { BiArrowBack, BiBookOpen } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

type LessonStatusProps = {
  subjectName: string;
  customData: string;
  imageUrl: string;
};

const LessonStatus: React.FunctionComponent<LessonStatusProps> = ({
  subjectName,
  customData,
  imageUrl,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={`${styles.lessonStatusContainer} flex flex-row-reverse items-center justify-start w-full p-2 rounded-xl relative dark:!text-black`}
    >
      <BiArrowBack
        className="absolute top-1/4 left-3 text-2xl "
        onClick={() => {
          navigate(-1);
        }}
      />
      <div
        className="w-20 h-20 flex items-center justify-center rounded-full p-2"
        id={styles.imgContainer}
      >
        <img
          src={String(imageUrl).replace(/(http[^\s])/i, "https:").replace("::", ":")}
          alt="img"
          className="   "
          style={{
            width: "80%",
            height: "80%",
          }}
        />
      </div>
      <div
        className={`${styles.items} flex flex-col items-center justify-evenly h-full mr-4 `}
      >
        <div
          className={`${styles.top} flex flex-row-reverse items-center justify-start w-full`}
        >
          <GoFile className="ml-1" />
          <span>{subjectName}</span>
        </div>
        <div
          className={`${styles.bottom} flex flex-row-reverse items-start justify-start w-full mt-2`}
        >
          <BiBookOpen />
          <span className="mr-2 text-xs">{customData}</span>
        </div>
      </div>
    </div>
  );
};

export default LessonStatus;
